export const stringsKey = "GroupConfiguration";
export const englishStrings = {
	removeGroupToolTip: "Remove Group",
	newGroupToolTip: "New Group",
	fileUploadErrorText: "The file upload field is required",
	whatsappRateLimitInfoMessage:
		"Please ensure WhatsApp rate limits before configuring group details.",
};
